mdApp.controller("TransitionHeader", ['$scope', '$element', function($scope, $element){
	var tl = new TimelineMax({paused: true}),
		$el = jQuery($element[0]),
		logo = $element[0].getElementsByClassName('logo')[0],
		svgCount = logo.getElementsByTagName('svg-sprite').length,
		svgsLoaded = 0,
		finished = false,
		menuItems = $element[0].getElementsByClassName('menu-item'),
		$menu_header = jQuery('#menu-header'),
		$_hero_section = jQuery('.hero-section');
		
	$scope.$on('svgloaded', function(){
		svgsLoaded++;
		if (svgsLoaded >= svgCount) {
			var svgs = logo.getElementsByTagName('svg');
			tl.fromTo(logo, 1, {width: "80px", height: "95px"}, {width: "40px", height: "40px", ease: Linear.easeNone})
			.fromTo(svgs[0], 1, {opacity: "1"}, {opacity: "0", ease: Linear.easeNone}, "0")
			.fromTo(svgs[1], 1, {opacity: "0"}, {opacity: "1", ease: Linear.easeNone}, "0")
			.fromTo($element[0], 1, {height: "166px"}, {height: "73px", ease: Linear.easeNone}, "0")
			// .set($element[0], {backgroundColor: "#fff"});
		}
	});

	window.addEventListener('scroll', transition);
	window.addEventListener('resize', transition);
	var iScrollPos = false;
	function transition(){
		var header_height = $el.outerHeight();
		var iCurScrollPos = jQuery(this).scrollTop();
        if ( jQuery(".main").hasClass('has-hero-section') ) {
			// $scope.scrollDistance = window.innerHeight - 100;
			$scope.scrollDistance = $_hero_section.outerHeight() - 100; 
		}else{
			$scope.scrollDistance = 150;
		}
		if ( window.innerWidth <= 768 ) {
			var p = 1;
		}else{
			var p = document.body.scrollTop/$scope.scrollDistance;
		}
		if( p < 1 ){
			tl.progress( p );
			if ( finished ) {
				$el.removeClass('finished');
				finished = false;
			}
		}else if( p >= 1 && !finished ){
			if ( tl._pauseTime < 1 ) {
				tl.tweenTo(1).duration(0.01);
			}
			$el.addClass('finished');
			finished = true;
		}
		if ( iCurScrollPos > iScrollPos && $el.hasClass('finished') && iScrollPos != false && !$menu_header.hasClass('active') ) {
			var up_distance = $scope.scrollDistance + 300;
			if( jQuery(".main").hasClass('has-hero-section') ){
				up_distance = $scope.scrollDistance + 100 + 150;
			}
			if( iCurScrollPos < up_distance ){
				return;
			}
			// if( jQuery("body").hasClass('home')  && iCurScrollPos < ( $scope.scrollDistance + 100 + 150 ) ){
			// 	return 
			// }
            TweenMax.to( $el, 0.5, { y: - + header_height, ease: Linear.easeNone });
        } else {
            TweenMax.to( $el, 0.5, { y: 0, ease: Linear.easeNone });
        }
        iScrollPos = iCurScrollPos;
	}
	transition();

	for (var i = 0; i < menuItems.length; i++) {
		menuItems[i].children[0].addEventListener('click', touchMenuHandler);
	}
	// $menu_header.on('touchstart' , touchMenuHandler );
	function touchMenuHandler(e){
		// return;
		// console.log(e.clientX);
		e.preventDefault();
		// return
		var offset = jQuery(e.target).offset();
		var left = e.clientX;
		var top = e.clientY;
		// var left = e.touches[0].clientX-offset.left;
		// var top = e.touches[0].clientY-offset.top+document.body.scrollTop;
		var circle = document.createElement('div');
		circle.setAttribute('class', 'circle');
		e.target.parentElement.insertBefore(circle, e.target);
		var tl = new TimelineMax({paused: true, onComplete: function(){
			window.location = e.target.href;
			e.target.parentElement.removeChild(circle);
		}});
		var radius =  Math.max(e.target.clientHeight, e.target.clientWidth);
		tl.fromTo(circle, 0.5, {width: 0, height: 0, left: left, top: top, opacity: 1, ease: Linear.easeNone}, {width: radius*2, height: radius*2, left: left-radius, top: top-radius, opacity: 0})
		.play();
	}
	jQuery('#logos-marks-and-symbol-modal').on('shown.bs.modal', function (e) {
		// $_logos_and_symbol_slider.resize();
		// transition();
		// console.log('helo world from dd')
		// tl.progress( 1 );
		// $el.addClass('finished');
        // TweenMax.to( $el, 0.5, { y: - + header_height, ease: Linear.easeNone });
		// transition();
		
		// TweenMax.to( $el, 0.5, { y: 0, ease: Linear.easeNone });
	})
	jQuery('#logos-marks-and-symbol-modal').on('hidden.bs.modal', function (e) {
		// tl.progress( 1 );
		// transition();
		// console.log('hidden');
	})
}]);
